{
  // Enable tracking of downloads in Google Analytics 
  const gaTrackDownloads = () => {
    // Check all anchors and elements marked with the ga-track-download class
    Array.prototype.forEach.call(document.querySelectorAll('a[href],.ga-track-download'), element => {
      element.addEventListener('click', event => {
        // Recognized file types
        const filetypeRE = /\.(?:zip|exe|dmg|pdf|docx?|xlsx?|pptx?|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
        // Target HREF of element, if available
        const href = element.href || '';
        // Domain of current website, accounting for country-level domains like co.uk
        const domain = location.hostname.match(/[^.]+(?:\.com?)?\.[^.]+$/)[0];
        let gaEvent = {};
        if (href.match(/^javascript:/)) {
          // Don't track javascript links
          return;
        }
        else if (href.match(/^mailto:/)) {
          // Email link
          gaEvent.action = 'click';
          gaEvent.category = 'email';
          gaEvent.label = href.replace(/^mailto:/, '');
          gaEvent.value = 0;
        }
        else if (href.match(filetypeRE)) {
          // File download
          gaEvent.action = 'click-' + href.match(/[^.]+$/)[0];
          gaEvent.category = 'download';
          gaEvent.label = href.replace(/\s+/g, '-');
          gaEvent.value = 0;
        }
        else if (href.match('/pdfondemand/')) {
          // PDF on demand
          gaEvent.action = 'click-pdfondemand';
          gaEvent.category = 'pdfondemand';
          gaEvent.label = href.match('/pdfondemand/.*')[0].replace(/\s+/g, '-');
          gaEvent.value = 0;
        }
        else if (href.match('/odf/|/od[st]-export\\?')) {
          // ODF export
          gaEvent.action = 'click-odf';
          gaEvent.category = 'odf';
          gaEvent.label = href.match('/odf/.*|/od[st]-export\\?.*')[0].replace(/\s+/g, '-');
          gaEvent.value = 0;
        }
        else if (href.match('/files\\?')) {
          // File library download
          gaEvent.action = 'click-files';
          gaEvent.category = 'files';
          gaEvent.label = href.match('/files\\?.*')[0].replace(/\s+/g, '-');
          gaEvent.value = 0;
        }
        else if (href.match(/^https?:/) && !href.match(domain.replace(/\\./g, '\\.'))) {
          // External link
          gaEvent.action = 'click';
          gaEvent.category = 'external';
          gaEvent.label = href.replace('^https?:/*', '');
          gaEvent.value = 0;
        }
        else if (href.match(/^tel:/)) {
          // Telephone number
          gaEvent.action = 'click';
          gaEvent.category = 'telephone';
          gaEvent.label = href.replace(/^tel:/, '');
          gaEvent.value = 0;
        }
        else if (~element.className.indexOf('ga-track-download')) {
          // Custom download element
          gaEvent.action = 'click';
          gaEvent.category = 'download';
          gaEvent.label = element.id || element.className.match(/^\S+/)[0];
          gaEvent.value = 0;
        }
        else {
          // Unknown link type
          return;
        }
        let callback;
        if ((gaEvent.category == 'external' || gaEvent.category == 'download' || gaEvent.category == 'files') && href && (element.target != '_blank')) {
          // For external or download links, set up a callback for following the link
          let callback_called = false;
          callback = () => {
            if (!callback_called) {
              callback_called = true;
              location.href = href;
            }
          };
          event.preventDefault();
          // Call callback after a 1 second timeout if Google Analytics fails
          setTimeout(callback, 1000);
        }
        if (typeof(ga) == 'function') {
          // Universal Analytics
          ga('send', 'event', gaEvent.category.toLowerCase(), gaEvent.action.toLowerCase(), gaEvent.label.toLowerCase(), gaEvent.value, {
            nonInteraction: (gaEvent.category == 'external'),
            hitCallback: callback
          });
        }
        else if (typeof(gtag) == 'function') {
          // gtag.js
          gtag('event', gaEvent.action.toLowerCase(), {
            event_category: gaEvent.category.toLowerCase(),
            event_label: gaEvent.label.toLowerCase(),
            value: gaEvent.value,
            non_interaction: (gaEvent.category == 'external'),
            event_callback: callback
          });
        }
        else {
          // Google Analytics not loaded
          console.log([
            'Track event:',
            ' Action: ' + gaEvent.action.toLowerCase(),
            ' Category: ' + gaEvent.category.toLowerCase(),
            ' Label: ' + gaEvent.label.toLowerCase(),
            ' Value: ' + gaEvent.value,
            ' Non-interaction: ' + ((gaEvent.category == external) ? 'Yes' : 'No'),
            ' Callback: ' + (callback ? 'Yes' : 'No')
          ].join('\r\n'));
          if (callback) {
            setTimeout(callback, 0);
          }
        }
        //alert('Tracking event called; check console log');
      });
    });
  };

  if (document.readyState != 'loading') {
    // HTML document is loaded, set up tracking
    gaTrackDownloads();
  }
  else {
    // Set up tracking once HTML document has finished loading
    document.addEventListener('DOMContentLoaded', gaTrackDownloads);
  }
}